import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import React from 'react';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { Text } from 'ui-components/components/text';
import { TextType } from 'ui-components/components/text/text-type';

import { pages } from '../../../nav-items';
import messages from './messages';
import style from './style.module.less';
import EmptyBoxIcon from '../../../../../svgs/empty-box.svg';

const addOnsCentralRoute = `/${pages.settings.location}/${pages.addOnMarketplace.location}`;

export const EmptyAddOnsCard = React.memo(() => {
  const intl = useIntl();
  return (
    <>
      <Text textType={TextType.H4} value={messages.addOns} />
      <div className={style['add-ons-card']}>
        <img alt={intl.formatMessage(messages.emptyBox)} className={style['empty-box']} src={EmptyBoxIcon} />
        <Text textType={TextType.Label} value={messages.noAddOnsYet} />
        <Text className={style['add-ons-description']} textType={TextType.Paragraph} value={messages.addOnsDescription} />
        <Link className={style['add-ons-marketplace-link-empty-state']} to={addOnsCentralRoute}>
          <Text textType={TextType.Caption} value={messages.showAllAddOns} />
          <FontAwesomeIcon className={style['right-arrow-empty-state']} icon={faArrowRight} />
        </Link>
      </div>
    </>
  );
});
